import { useForm } from "react-hook-form";
import { formValues, schema } from "./validations";
import { CONFIRM_PASSWORD, NEW_PASSWORD } from "./consts";
import { zodResolver } from "@hookform/resolvers/zod";
import { useState } from "react";
import { Eye, EyeOff } from "lucide-react";
import { getRequiredFields } from "@/lib/utils";
import { toast } from "@/components/Toast";
import { useResetUserPasswordMutation } from "@/services";

const useResetPassword = ({
  selectedUser,
  setOpen 
}: {
  selectedUser: any;
  setOpen: React.Dispatch<React.SetStateAction<boolean>>;
}) => {
  const [isPassword, setIsPassword] = useState<any>({
    newPassword: true,
    confirm: true,
  });

  const form = useForm<formValues>({
    defaultValues: {
      [NEW_PASSWORD]: "",
      [CONFIRM_PASSWORD]: ""
    },
    resolver: zodResolver(schema),
  });

  const requiredFields = getRequiredFields(schema);

  const onEyeIconClick = (key: string) => () => {
    setIsPassword({ ...isPassword, [key]: !isPassword[key] });
  };

  const Icon = isPassword ? Eye : EyeOff;

  const { mutate: resetUserPassword, isPending: isResetPasswordPending } =
    useResetUserPasswordMutation({
      onError: (error?: any) => {
        toast.error(
          typeof error?.response?.data?.message === "string"
            ? error?.response?.data?.message
            : "Something went wrong"
        );
      },
      onSuccess: () => {
        toast.success("Password reset successfully.");
        setOpen(false);
      },
    });

  const onSubmit = (data: any) => {
    if (data[NEW_PASSWORD] !== data[CONFIRM_PASSWORD]) {
      toast.error("Passwords must match");
      return;
    }

    resetUserPassword({
      data: {
        userId: selectedUser?.userId,
        newPassword: data[NEW_PASSWORD],
      },
    });
  }

  return {
    form,
    onEyeIconClick,
    Icon,
    isPassword,
    requiredFields,
    onSubmit,
    isResetPasswordPending
  }
}

export default useResetPassword;